export default [
  {
    path: "/users/customers",
    name: "CustomerList",
    meta: { title: "Customers" },
    component: () => import("@/modules/users/customers/views/CustomerList.vue"),
  },
  {
    path: "/users/customers/view/:id",
    meta: {title : 'view Customer'},
    name: "ViewCustomer",
    component: () => import("@/modules/users/customers/views/Customer.vue"),
  },
  {
    path: "/users/admins",
    name: "AdminList",
    meta: { title: "Admins" },
    component: () => import("@/modules/users/admins/views/AdminList.vue"),
  },
  {
    path: "/users/operators",
    name: "OperatorList",
    meta: { title: "Operators" },
    component: () =>
      import("@/modules/users/operators/views/OperatorsList.vue"),
  },
  {
    path: "/users/operators/edit/:id",
    meta:{ title: 'Edit Operator' },
    name: "EditOperator",
    component: () => import("@/modules/users/operators/views/Operator.vue"),
  },
  {
    path: "/users/operators/add",
    name: "AddOperator",
    meta:{ title: 'Add Operator' },
    component: () => import("@/modules/users/operators/views/Operator.vue"),
  },
];